<template>
    <div class="main_unit report">
        <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        <component v-if="!isLoading"
                   :is="currentPage()"
                   :data="data"
                   :upper-title="title.upper"
                   :lower-title="title.lower"
                   :error-text="errorText"
                   :validation-error-text="validationErrorText"
                   :is-loading="isLoading"
                   :selectDate="selectDate"
                   :ref="currentPage()"
                   @refresh-data="fetchData"
                   :staff-id="currentStaffId"
                   @update-staff-id="handleStaffIdChange"
        ></component>
        <component v-if="!isLoading && existDailyCheck('dailyCheck2') && currentPage() === 'DailyCheckReport'"
                   :is="currentPage()"
                   :data="data"
                   :key-name="'dailyCheck2'"
                   :upper-title="upperTitle"
                   :lower-title="lowerTitle"
                   :error-text="errorText"
                   :validation-error-text="validationErrorText"
                   :is-loading="isLoading"
                   :selectDate="selectDate"
                   @refresh-data="fetchData"
                   :staff-id="currentStaffId"
                   @update-staff-id="handleStaffIdChange"
        ></component>
        <div class="prev_box">
            <div class="box_fix">
                <a v-show="index > 0" role="button" @click.prevent.stop="operationCheck('befoer')"><i class="fas fa-chevron-left prev_next_icn"></i><br>
                    前<br>
                    <span v-show="index === 1" class="icon-icn_cl_sheet" style=" font-size: 36px;"></span>
                    <span v-show="index === 2" class="icon-icn_cl_yubi" style=" font-size: 36px;"></span>
                </a>
            </div>
        </div>
        <div class="next_box">
            <div class="box_fix">
                <a v-show="index < 2" role="button" @click.prevent.stop="operationCheck('next')"><i class="fas fa-chevron-right prev_next_icn"></i><br>
                    次<br>
                    <span v-show="index === 0" class="icon-icn_cl_yubi" style=" font-size: 36px;"></span>
                    <span v-show="index === 1" class="icon-icn_cl_staff" style=" font-size: 36px;"></span>
                </a>
            </div>
        </div>
        <div class="overlay" v-show="showContent">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">コメント登録確認</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>入力したコメントはまだ登録されていません。画面遷移してよろしいですか？</p>
                    </div>
                    <div class="btn_submit_box">
                        <div class="btn_submit2">
                            <a href="#" @click.prevent.stop="closeCheckModel">キャンセル</a>
                        </div>
                        <div class="btn_submit">
                            <a href="#" @click.prevent.stop="actionCall">OK</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DailyCheckReport from '@/app/components/DailyCheckReport.vue'
    import HealthCheckReport from '@/app/components/HealthCheckReport.vue'
    import CookCheckReport from '@/app/components/CookCheckReport.vue'
    import PulseLoader from '@/app/components/PulseLoader.vue'
    import Message from '@/app/components/Message.vue'
    export default {
        name: 'Report',
        components: {
            PulseLoader,
            DailyCheckReport,
            HealthCheckReport,
            CookCheckReport,
            Message
        },
        filters: {
            convertNull: function (value) {
                return value === null ? '　': value
            }
        },
        props: {
            date: {
                type: Date,
                required: true,
            },
            confirmed: {
                type: Boolean,
                required: true
            },
            commentReFlg:{
                type: Boolean,
                required: true
            }
        },
        data: function () {
            return {
                showContent: false,
                actionStatus: "",
                commentFlg: false,
                isLoading: true,
                index : 0,
                data: {
                    comment: {},
                    report: {
                        dailyCheck: {},
                        healthCheck: {},
                        cookCheck: {},
                    },
                    reportCommentAlert: {
                      dailyCheck: {
                        isAlert:0
                      },
                      healthCheck: {
                        isAlert:0
                      },
                      cookCheck: {
                        isAlert:0
                      },
                    },
                    staffList:{},
                },
                title: {
                    lower: '',
                    upper: '',
                },
                page: [
                    'dailyCheck',
                    'cookCheck',
                    'healthCheck',
                ],
                errorText: '',
                validationErrorText: '',
                reportType: 1,
                alertMessage:'入力エラーがあります。',
                currentStaffId: null,
            }
        },
        computed: {
            managerName: function () {
                return this.$store.getters['store/adminName']
            },
            upperTitle: function () {
                if (this.existDailyCheck('dailyCheck2') && this.existDailyCheck('dailyCheck1')) {
                    return this.data.dailyCheck.dailyCheck2.upperButtonName
                }
                return null
            },
            lowerTitle: function () {
                if (this.existDailyCheck('dailyCheck2') && this.existDailyCheck('dailyCheck1')) {
                    return this.data.dailyCheck.dailyCheck2.lowerButtonName
                }
                return null
            },
            brandPath: function () {
                return this.$route.params.brandPath
            },
            role: function () {
                return Number(this.$store.getters['manager/manager'].authorityKbn)
            },
            isStoreManager: function () {
                return this.role === 4
            },
            isCompanyManager: function () {
                return this.role === 2
            },
            isOtherManager: function () {
                return this.role === 6
            },
            selectDate: function(){
                var selectDate = this.date.getFullYear() + '/' + (this.date.getMonth() + 1) + '/' + this.date.getDate();
                return selectDate;
            }
        },
        watch: {
            confirmed (value) {
                if (value === true) {
                    this.submit()
                }
            },
            '$route': function () {
                this.fetchData()
            },
            // コメント差分
            commentFlg:function(){
                if(this.commentFlg){
                    // 親のフラグを操作
                    this.$parent.commentFlg = true;
                }
                else{
                    this.$parent.commentFlg = false;
                }
            },
            commentReFlg:function(){
                // 親の変更に伴い、このパラメータを変更する
                if(this.commentReFlg){
                    // 親のフラグを操作
                    this.commentFlg = true;
                }
                else{
                    this.commentFlg = false;
                }
            }
        },
        methods: {
            prev: function () {
                this.index--
                this.setReportType(this.index)
                this.setTitle()
                this.$emit('page-changed', this.index)
            },
            next: function () {
                this.index++
                this.setReportType(this.index)
                this.setTitle()
                this.$emit('page-changed', this.index)
            },
            currentPage: function () {
                const page = [
                    'DailyCheckReport',
                    'CookCheckReport',
                    'HealthCheckReport',
                ]

                return page[this.index]
            },
            setTitle: function () {
                if (this.index === 0) {
                    let key = ''
                    if (this.existDailyCheck('dailyCheck1')) {
                        key = 'dailyCheck1'
                    } else if(this.existDailyCheck('dailyCheck2')) {
                        key = 'dailyCheck2'
                    }
                        this.title.lower = key !== '' ? this.data.dailyCheck[key].lowerButtonName : ''
                        this.title.upper = key !== '' ? this.data.dailyCheck[key].upperButtonName : ''
                } else {
                    this.title.lower = this.data[this.page[this.index]].lowerButtonName
                    this.title.upper = this.data[this.page[this.index]].upperButtonName
                }
            },
            hasProperty: function (obj,key) {
                return !!(obj) && Object.prototype.hasOwnProperty.call(obj, key)
            },
            existDailyCheck: function (key) {
                return this.hasProperty(this.data, 'dailyCheck') && this.hasProperty(this.data.dailyCheck, key) && this.data.dailyCheck[key].buttonList.length > 0
            },
            getApiUrl: function () {
                let brand = this.$store.getters['brand/data']
                let store = this.$store.getters['store/data']
                return this.$apiEndpoint+'manage/brand/' + brand.id + '/store/' + store.store_id + '/report/' + this.date.getFullYear() + '/' + (this.date.getMonth() + 1) + '/' + this.date.getDate()
            },
            fetchData: function () {
                this.isLoading = true

                let url = this.getApiUrl()
                this.$axios.get(url).then(response => {
                        this.data.healthCheck = response.data.report.healthCheck
                        this.data.dailyCheck = response.data.report.dailyCheck
                        this.data.cookCheck = response.data.report.cookCheck
                        this.data.healthCheck.comment = response.data.comment.healthCheck
                        this.data.dailyCheck.comment = response.data.comment.dailyCheck
                        this.data.cookCheck.comment = response.data.comment.cookCheck
                        this.data.staffList = response.data.staffList
                        if(this.data.staffList != null){
                            this.currentStaffId = this.data.staffList[0].id;
                        }

                        this.setTitle()
                }).catch(err => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}
                    if (err.customError.code == 401) {
                        //店舗管理者のtokenエラーの場合
                        this.$cookies.set('user-api-token', '', 0)
                        this.$store.dispatch('store/doClear')
                    }
                    if (err.customError) {
                        error = Object.assign(error, err.customError)
                    }
                    this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                }).finally(()=> this.isLoading = false)
            },
            clearError: function () {
                this.validationErrorText = ''
                this.errorText = ''
            },
            submit: function () {
                let validationLengthResult = null
                let request = {
                    'report_type': this.reportType
                }
                const url = this.getApiUrl()

                this.clearError()

                let requestComment = ''
                let commentsDatetime = ''
                if (this.isStoreManager) {
                    requestComment = this.data[this.page[this.index]].comment.storeManager.comment
                    commentsDatetime = this.data[this.page[this.index]].comment.storeManager.commentsDatetime
                    request.is_alert = 0;
                } else if (this.isCompanyManager) {
                    requestComment = this.data[this.page[this.index]].comment.companyManager.comment
                    commentsDatetime = this.data[this.page[this.index]].comment.companyManager.commentsDatetime
                    request.is_alert = this.data.reportCommentAlert[this.page[this.index]].isAlert;
                } else {
                    requestComment = this.data[this.page[this.index]].comment.otherManager.comment
                    commentsDatetime = this.data[this.page[this.index]].comment.otherManager.commentsDatetime
                    request.is_alert = this.data.reportCommentAlert[this.page[this.index]].isAlert;
                }

                validationLengthResult = this.validateLength(requestComment)
                request.comment = requestComment
                request.comments_datetime = commentsDatetime

                if (! validationLengthResult.result) {
                    this.validationErrorText = validationLengthResult.message
                    this.$emit('submitted', false)
                    this.scrollTop();
                    return
                }

                let result = null
                this.$axios.post(url, request)
                    .then(response => {
                            result = true
                        if (this.isStoreManager) {
                            this.$set(this.data[this.page[this.index]].comment.storeManager, 'commentsDatetime', response.data.commentList[this.page[this.index]].storeManager.commentsDatetime)
                        } else if (this.isCompanyManager) {
                            this.$set(this.data[this.page[this.index]].comment.companyManager, 'commentsDatetime', response.data.commentList[this.page[this.index]].companyManager.commentsDatetime)
                        } else {
                            this.$set(this.data[this.page[this.index]].comment.otherManager, 'commentsDatetime', response.data.commentList[this.page[this.index]].otherManager.commentsDatetime)
                        }

                        if(this.currentPage() == 'DailyCheckReport'){
                            this.$refs.DailyCheckReport.updateUserCommentDatetime()
                        } else if (this.currentPage() == 'CookCheckReport') {
                            this.$refs.CookCheckReport.updateUserCommentDatetime()
                        } else if (this.currentPage() == 'HealthCheckReport') {
                            this.$refs.HealthCheckReport.updateUserCommentDatetime()
                        }

                    }).catch(err => {
                    result = false
                    let error = {
                        button: {
                            path: {name: 'top', params: { brandPath: this.brandPath }}
                        }}
                    if (err.customError) {
                        if (err.customError.code == 400) {
                            this.errorText = err.customError.message
                            this.scrollTop();
                            return
                        } else if (err.customError.code == 401) {
                            //店舗管理者のtokenエラーの場合
                            this.$cookies.set('user-api-token', '', 0)
                            this.$store.dispatch('store/doClear')
                        } else if (err.customError.code == 409) {
                            this.errorText = err.customError.message
                            this.scrollTop();
                            return
                        }
                        error = Object.assign(error, err.customError)
                    }
                    this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                }).finally(()=> this.$emit('submitted', result))
            },
            validateLength: function (comment) {
                if (this.isString(comment) && comment.length > 200) {
                    return { result: false, message: '総括コメントは200文字以下で入力してください。' }
                }
                return { result: true, message: '' }
            },
            isString: function (obj) {
                return typeof (obj) === 'string' || obj instanceof String
            },
            setReportType: function (index) {
                if (index === 0) {
                    this.reportType = 1
                } else if (index === 1) {
                    this.reportType = 2
                } else if (index === 2) {
                    this.reportType = 3
                }
            },
            scrollTop() {
                window.scrollTo(0,0);
            },
            operationCheck(action){
                this.actionStatus = action;
                if(this.commentFlg){
                    this.showContent = true;
                    return null;
                }
                // 差分がない場合
                this.actionCall();
            },
            actionCall(){
                // 判定フラグを初期化
                this.commentFlg = false;
                this.showContent = false;
                switch (this.actionStatus) {
                    case "befoer":
                        this.prev();
                        break;
                    case "next":
                        this.next();
                        break;
                }
            },
            closeCheckModel(){
                this.showContent = false;
            },
            handleStaffIdChange(staffId) {
                // 子から受け取った新しいIDでデータを更新
                this.currentStaffId = staffId;
            }
        },
        mounted () {
            this.fetchData()
        }
    }
</script>
